import type { RoleDef } from "./wire-types";
import { english, type Translate } from "../i18n/translate";

/** Roles grouped by pack, own before template; insertion order keeps the API's name order within a group. */
export function roleGroups(roles: RoleDef[], t: Translate = english): Array<[string, RoleDef[]]> {
  const groups = new Map<string, RoleDef[]>();
  const sorted = [...roles.filter((r) => !r.is_template), ...roles.filter((r) => r.is_template)];
  for (const r of sorted) {
    const label = r.pack_name
      ? r.is_template
        ? t("{pack} v{version} (template)", { pack: r.pack_name, version: r.pack_version ?? "?" })
        : t("{pack} v{version}", { pack: r.pack_name, version: r.pack_version ?? "?" })
      : r.is_template
        ? t("Platform roles")
        : t("This organisation's roles");
    groups.set(label, [...(groups.get(label) ?? []), r]);
  }
  return [...groups];
}
